<template>
    <div class="ingredient-picker" style="margin-top: 1em;">
        <label style="margin-bottom: 0.3em;">
            Vyberte ingredienci:
        </label>
        <div style="float: left; padding-top: 0.5em;">
           <i class="fa fa-search"></i>
        </div>
        <div style="margin-left: 2em;">
            <basic-select :options="options"
                          :selected-option="item"
                          placeholder="vyhledávajte nebo vyberte ze seznamu"
                          @select="selectItem">
            </basic-select>
        </div>
    </div>
</template>

<script>
    import { BasicSelect } from 'vue-search-select';

    export default {
        components: {
            BasicSelect
        },

        props: {
            'options': {required: true}
        },

        data () {
            return {
                searchText: '', // If value is falsy, reset searchText & searchItem
                item: {
                    value: '',
                    text: ''
                }
            }
        },

        methods: {
            selectItem(item) {
                let vm = this;

                vm.$emit('item-selected', item.value);

                vm.item =  {
                    value: '',
                    text: ''
                };
            }
        }
    }
</script>